import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { formatDOP } from "@/lib/format";

// Retenciones asumidas por la empresa + anticipos (RE) a aplicar al E41/E43
export function ExpenseAdvancesBox({ docType, supplierId, incurredBy, total, net, grossUp, setGrossUp, selected, setSelected }) {
  const [advances, setAdvances] = useState([]);
  const hasRet = net < total - 0.005;

  useEffect(() => {
    const params = docType === "E43" ? { name: incurredBy || "" } : { counterpart_id: supplierId || "" };
    if (!params.name && !params.counterpart_id) { setAdvances([]); setSelected([]); return; }
    api.get("/receipts-open-advances", { params }).then(({ data }) => {
      setAdvances(data);
      setSelected((sel) => sel.filter((id) => data.some((a) => a.id === id)));
    }).catch(() => { setAdvances([]); setSelected([]); });
  }, [docType, supplierId, incurredBy]); // eslint-disable-line react-hooks/exhaustive-deps

  const payable = grossUp && hasRet ? total : net;
  const applied = Math.min(advances.filter((a) => selected.includes(a.id)).reduce((s, a) => s + a.advance_balance, 0), payable);
  const toggle = (id) => setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);

  return (
    <div className="space-y-2 rounded-md border p-3 text-sm" data-testid="expense-advances-box">
      {docType !== "E43" && (
        <label className="flex items-start gap-3">
          <Switch checked={grossUp} onCheckedChange={setGrossUp} data-testid="expense-gross-up" />
          <span>
            <b>La empresa asume las retenciones</b> — los montos digitados son lo que recibe el suplidor.
            {grossUp && hasRet && (
              <span className="block text-xs text-muted-foreground" data-testid="expense-gross-up-hint">
                Al suplidor le llegarán {formatDOP(total)} limpios. Amelia calcula al guardar el monto mayor a declarar a la DGII (con las retenciones incluidas).
              </span>
            )}
          </span>
        </label>
      )}
      {advances.length > 0 && (
        <div data-testid="expense-advances-list">
          <div className="overline mb-1">Anticipos pendientes de este beneficiario</div>
          {advances.map((a) => (
            <label key={a.id} className="flex items-center gap-2 py-0.5">
              <input type="checkbox" checked={selected.includes(a.id)} onChange={() => toggle(a.id)} data-testid={`expense-advance-${a.number}`} />
              <span className="font-mono">{a.number}</span> · {String(a.date || "").slice(0, 10)} · {formatDOP(a.advance_balance)}
            </label>
          ))}
          {selected.length > 0 && (
            <p className="text-xs mt-1" data-testid="expense-advance-summary">
              Anticipo aplicado: <b>{formatDOP(applied)}</b> · Pagar ahora: <b>{formatDOP(payable - applied)}</b> (sin nueva salida por lo ya adelantado)
            </p>
          )}
        </div>
      )}
    </div>
  );
}
